// ================================================================
// modeConfig.js — 각 모드별 화면 텍스트 설정 파일
//
// 앱에는 4가지 모드가 있습니다:
//   - diary    (오늘 하루)  : 하루 일과/감정 이야기
//   - note     (생각 정리) : 자유로운 생각 정리
//   - planner  (할 일 정리): 계획 및 할 일 정리
//   - decision (고민 상담) : 선택/고민 앞에서 생각 정리
//   - dream    (꿈과 목표) : 가치 발견 + 비전 구체화 + 첫 행동
//
// 각 모드의 아이콘, 제목, 부제목, 입력창 placeholder를
// 여기서 직접 수정하세요.
// ================================================================

export const MODE_CONFIG = {

  // ── 오늘 하루 모드 ───────────────────────────────────────────
  diary: {
    icon: '📔',
    label: '오늘 하루',
    title: '오늘 하루는 어땠나요?',
    subtitle: '편하게 이야기해주세요',
    placeholder: '오늘 하루를 한 문장으로.',
    freewriteSubtitle: '자유롭게 기록해보세요',
    freewritePlaceholder: '오늘 하루를 자유롭게 적어주세요.',
  },

  // ── 생각 정리 모드 ───────────────────────────────────────────
  note: {
    icon: '📝',
    label: '생각 정리',
    title: '무슨 생각 하고 있나요?',
    subtitle: '떠오르는 대로 적어주세요',
    placeholder: '지금 떠오르는 생각을 한 문장으로.',
    freewriteSubtitle: '자유롭게 적어보세요',
    freewritePlaceholder: '생각, 메모, 스크랩 등 자유롭게 적어주세요.',
  },

  // ── 할 일 정리 모드 ──────────────────────────────────────────
  planner: {
    icon: '📋',
    label: '할 일 정리',
    title: '오늘 뭐 하실 건가요?',
    subtitle: '같이 정리해볼게요',
    placeholder: '앞으로 뭐 할 건지 한 문장으로.',
  },

  // ── 고민 상담 모드 ───────────────────────────────────────────
  decision: {
    icon: '🧭',
    label: '고민 상담',
    title: '무엇 때문에 고민인가요?',
    subtitle: '같이 생각해볼게요',
    placeholder: '고민되는 걸 한 문장으로.',
    freewriteSubtitle: '자유롭게 적어보세요',
    freewritePlaceholder: '고민되는 것들을 자유롭게 적어주세요.',
  },

  // ── 꿈과 목표 모드 ──────────────────────────────────────────
  dream: {
    icon: '🌱',
    label: '꿈과 목표',
    title: '앞으로 어떻게 살고 싶나요?',
    subtitle: '같이 찾아볼게요',
    placeholder: '요즘 드는 생각을 한 문장으로.',
    freewriteSubtitle: '자유롭게 적어보세요',
    freewritePlaceholder: '꿈과 목표를 자유롭게 적어주세요.',
  },

};
